export { GameCard } from './GameCardDefault/GameCard';
export { GameCardSvgColors } from './GameCardSvgColors/GameCardSvgColors';
